import { IconButton, Tooltip, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import classes from "./ScrollToTopButton.module.scss";

const ScrollToTopButton: React.FC = () => {
    const [scrollButton, setScrollButton] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleScroll = () => {
            setScrollButton(window.scrollY > 300);
        };

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    // Calculate responsive positioning
    const getBottomPosition = () => {
        if (windowWidth <= 375) return "75px";
        if (windowWidth <= 767) return "80px";
        if (windowWidth <= 1024) return "20px";
        return "24px";
    };

    const getRightPosition = () => {
        if (windowWidth <= 375) return "12px";
        if (windowWidth <= 767) return "16px";
        if (windowWidth <= 1024) return "20px";
        return "24px";
    };

    // Render the button using a portal to bypass any container positioning issues
    const buttonElement = (
        <Zoom in={scrollButton} appear unmountOnExit>
            <div
                style={{
                    position: "fixed",
                    bottom: getBottomPosition(),
                    right: getRightPosition(),
                    zIndex: 1050,
                    pointerEvents: scrollButton ? "auto" : "none",
                }}
            >
                <Tooltip title="Back to top" placement="left">
                    <IconButton
                        onClick={scrollUp}
                        className={classes.scrollToTopBtn}
                        aria-label="scroll to top"
                        style={{
                            position: "relative",
                            zIndex: 1051,
                        }}
                    >
                        <KeyboardArrowUpIcon />
                    </IconButton>
                </Tooltip>
            </div>
        </Zoom>
    );

    // Render to document body to ensure proper fixed positioning
    return createPortal(buttonElement, document.body);
};

export default ScrollToTopButton;
